export default [
    {
        path: '/articles',
        name: 'articles',
        component: () => import( /* webpackChunkName: "articles" */ '@/views/rest/Articles.vue')
    },
    {
        path: '/articles/add',
        name: 'articleAdd',
        component: () => import( /* webpackChunkName: "article" */ '@/views/rest/Article.vue')
    },
    {
        path: '/articles/:id',
        name: 'articleEdit',
        component: () => import( /* webpackChunkName: "article" */ '@/views/rest/Article.vue')
    },
    {
        path: '/bulletins',
        name: 'bulletins',
        component: () => import( /* webpackChunkName: "bulletins" */ '@/views/rest/Bulletins.vue')
    },
    {
        path: '/bulletins/add',
        name: 'bulletinAdd',
        component: () => import( /* webpackChunkName: "bulletin" */ '@/views/rest/Bulletin.vue')
    },
    {
        path: '/bulletins/edit/:id',
        name: 'bulletin',
        component: () => import( /* webpackChunkName: "bulletin" */ '@/views/rest/Bulletin.vue')
    },
    {
        path: '/counties',
        name: 'counties',
        component: () => import( /* webpackChunkName: "counties" */ '@/views/rest/Counties.vue')
    },
    {
        path: '/counties/:id',
        name: 'county',
        component: () => import( /* webpackChunkName: "county" */ '@/views/rest/County.vue')
    },
    {
        path: '/countyTemplate',
        name: 'countyTemplate',
        component: () => import( /* webpackChunkName: "countyTemplate" */ '@/views/rest/CountyTemplate.vue')
    },
    {
        path: '/moveds',
        name: 'moveds',
        component: () => import( /* webpackChunkName: "moveds" */ '@/views/rest/Moveds.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import( /* webpackChunkName: "news" */ '@/views/rest/News.vue')
    },
    {
        path: '/news/:id',
        name: 'newsitem',
        component: () => import( /* webpackChunkName: "newsitem" */ '@/views/rest/NewsItem.vue')
    },
    {
        path: '/newsitemadd',
        name: 'newsitemadd',
        component: () => import( /* webpackChunkName: "newsitem" */ '@/views/rest/NewsItem.vue')
    },
    {
        path: '/populations/:id',
        name: 'population',
        component: () => import( /* webpackChunkName: "population" */ '@/views/rest/Population.vue')
    },
    {
        path: '/populations',
        name: 'populations',
        component: () => import( /* webpackChunkName: "populations" */ '@/views/rest/Populations.vue')
    },
    {
        path: '/populationTemplates/add',
        name: 'populationTemplateAdd',
        component: () => import( /* webpackChunkName: "populationTemplate" */ '@/views/rest/PopulationTemplate.vue')
    },
    {
        path: '/populationTemplates/edit/:id',
        name: 'populationTemplateEdit',
        component: () => import( /* webpackChunkName: "populationTemplate" */ '@/views/rest/PopulationTemplate.vue')
    },
    {
        path: '/populationTemplates',
        name: 'populationTemplates',
        component: () => import( /* webpackChunkName: "populationTemplates" */ '@/views/rest/PopulationTemplates.vue')
    },
    {
        path: '/printers',
        name: 'printers',
        component: () => import( /* webpackChunkName: "printers" */ '@/views/rest/Printers.vue')
    },
    {
        path: '/printers/add',
        name: 'printerAdd',
        component: () => import( /* webpackChunkName: "printer" */ '@/views/rest/Printer.vue')
    },
    {
        path: '/printers/:id',
        name: 'printer',
        component: () => import( /* webpackChunkName: "printer" */ '@/views/rest/Printer.vue')
    },
    {
        path: '/servers',
        name: 'servers',
        component: () => import( /* webpackChunkName: "servers" */ '@/views/rest/Servers.vue')
    },
    {
        path: '/servers/edit/:id',
        name: 'server',
        component: () => import( /* webpackChunkName: "server" */ '@/views/rest/Server.vue')
    },
    {
        path: '/servers/add',
        name: 'serverAdd',
        component: () => import( /* webpackChunkName: "server" */ '@/views/rest/Server.vue')
    }
]